import store from '@/store/index.js'
let dic = store.state.dic;
import {
    getOrgOptions,
} from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: dic._COLLEGE_OPTIONS,
            clearable: true,
            change(data) {
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classIdList = [];
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, 1, null);
                    params = {
                        parentId: data,
                        grade: that.pageParams.grade,
                        type: 'class'
                    }
                    that.searchItems[2].options = [];
                    that.pageParams.classIdList = [];
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "年级",
            span: 6,
            type: 'year',
            model: "grade",
            clearable: true,
            change(data) {
                that.searchItems[3].options = [];
                let parentId = "";
                if (that.pageParams.classIdList &&that.pageParams.classIdList.size>0) {
                    parentId = that.pageParams.classIdList.join(",");
                } else if (that.pageParams.majorId) {
                    parentId = that.pageParams.majorId;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "专业",
            span: 6,
            placeholder: '请选择专业',
            type: 'select',
            model: "majorId",
            clearable: true,
            options: [],
            change(data) {
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                let parentId = "";
                if (data) {
                    parentId = data;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: that.pageParams.grade,
                    type: 'class'
                }
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "班级",
            span: 6,
            placeholder: '请选择班级',
            type: 'select',
            model: "classIdList",
            multiple:true,
            clearable: true,
            options: [],
        },
        {
            label: "培养层次",
            span: 6,
            type: 'select',
            options:dic._DEGREE,
            model: "academicDegree",
            clearable: true,
        },
        {
            label: "学制",
            span: 6,
            type: 'select',
            options: dic._ACADEMICYEAR,
            model: "academicYear",
            clearable: true,
        },
        {
            label: "学号/姓名",
            span: 6,
            placeholder: '请输入',
            model: "studentNoOrName",
        },
        {
            label: "性别",
            span: 6,
            type: 'select',
            options: dic._SEXS,
            model: "sex",
            clearable: true,
        },
        {
            label: "身份证号",
            span: 6,
            placeholder: '请输入',
            model: "idCard",
        },
        {
            label: "联系方式",
            span: 6,
            placeholder: '请输入',
            model: "phoneNumber",
        },
        {
            label: "是否全部完成",
            span: 6,
            labelWidth: '120px',
            placeholder: '请选择',
            model: "isComplete",
            type: 'select',
            options: dic._IS,
            clearable: true,
        },
        {
            label: "未完成事项",
            span: 6,
            labelWidth: '120px',
            placeholder: '请选择',
            model: "noCompleteLinkIdList",
            type: 'select',
            multiple:true,
            options: []
        },
    ]
    const tableColumns = [
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            minWidth: 180,
            show: true
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     minWidth: 180,
        //     show: true
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            minWidth: 260,
            show: true
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            minWidth: 160,
            show: true
        },
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        // {
        //     label: "身份证号",
        //     prop: "idCard",
        //     align: "center",
        //     minWidth: 180,
        //     show: true
        // },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true
        },
        {
            label: "性别",
            prop: "sex",
            align: "center",
            show: true
        },
        {
            label: "培养层次",
            prop: "academicDegreeName",
            align: "center",
            show: true
        },
        {
            label: "是否全部完成",
            prop: "isComplete",
            align: "center",
            minWidth: 120,
            show: true
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
